import { Typography, TypographyTypeMap } from '@mui/material';
import { DefaultComponentProps } from '@mui/material/OverridableComponent';
import { PropsWithChildren } from 'react';

export const Title = ({
  children,
  ...props
}: PropsWithChildren<DefaultComponentProps<TypographyTypeMap>>) => (
  <Typography variant="h3" fontWeight={500} color="primary.main" {...props}>
    {children}
  </Typography>
);

export const SubTitle = ({
  children,
  ...props
}: PropsWithChildren<DefaultComponentProps<TypographyTypeMap>>) => (
  <Typography variant="h6" fontWeight={700} color={'primary.main'} {...props}>
    {children}
  </Typography>
);

export const Body = ({
  children,
  ...props
}: PropsWithChildren<DefaultComponentProps<TypographyTypeMap>>) => (
  <Typography variant="body1" {...props}>
    {children}
  </Typography>
);

export const Caption = ({
  children,
  ...props
}: PropsWithChildren<DefaultComponentProps<TypographyTypeMap>>) => (
  <Typography variant="caption" {...props}>
    {children}
  </Typography>
);
